// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc4754ff","732":"c1976dce","977":"7c8f1ae7"}[chunkId] + ".chunk.js";
};